const mockData = {
  learningGoal: 'advance_career',
  editMode: 'static',
  visibilityLearningGoal: 'private',
};

// Raw (snake_case) response of GET /api/certificates/v0/certificates/<username>/.
// Used instead of the real request when USE_MOCK_CERTIFICATES is 'true'.
export const mockCertificates = [
  {
    username: 'staff',
    status: 'downloadable',
    course_display_name: 'Основи програмування на Python',
    grade: '0.97',
    course_id: 'course-v1:Prometheus+PY101+2024_T1',
    course_organization: 'Prometheus',
    modified_date: '2024-02-12T10:15:30.000000Z',
    is_passing: true,
    download_url: '/certificates/a1b2c3d4e5f60718293a4b5c6d7e8f90',
    certificate_type: 'verified',
    created_date: '2024-02-12T10:15:29.000000Z',
  },
  {
    username: 'staff',
    status: 'downloadable',
    course_display_name: 'Вступ до Data Science',
    grade: '0.91',
    course_id: 'course-v1:Prometheus+DS101+2024_T1',
    course_organization: 'Prometheus',
    modified_date: '2024-03-28T14:42:11.000000Z',
    is_passing: true,
    download_url: 'https://example.com/certificates/ds101-2024',
    certificate_type: 'verified',
    created_date: '2024-03-28T14:42:10.000000Z',
  },
  {
    username: 'staff',
    status: 'downloadable',
    course_display_name: 'Основи UX/UI дизайну',
    grade: '0.84',
    course_id: 'course-v1:Prometheus+UX100+2024_T2',
    course_organization: 'Prometheus',
    modified_date: '2024-05-07T09:05:00.000000Z',
    is_passing: true,
    download_url: '/certificates/0f9e8d7c6b5a49382716f5e4d3c2b1a0',
    certificate_type: 'honor',
    created_date: '2024-05-07T09:04:59.000000Z',
  },
  {
    username: 'staff',
    status: 'downloadable',
    course_display_name: 'Цифровий маркетинг: від стратегії до результату',
    grade: '0.78',
    course_id: 'course-v1:Prometheus+DM201+2024_T2',
    course_organization: 'Prometheus',
    modified_date: '2024-06-19T17:30:45.000000Z',
    is_passing: true,
    download_url: 'https://example.com/certificates/dm201-2024',
    certificate_type: 'professional',
    created_date: '2024-06-19T17:30:44.000000Z',
  },
  {
    username: 'staff',
    status: 'downloadable',
    course_display_name: 'Git та GitHub для початківців',
    grade: '1.00',
    course_id: 'course-v1:Prometheus+GIT100+2024_T3',
    course_organization: 'Prometheus',
    modified_date: '2024-08-02T12:00:00.000000Z',
    is_passing: true,
    download_url: '/certificates/1a2b3c4d5e6f708192a3b4c5d6e7f809',
    certificate_type: 'verified',
    created_date: '2024-08-02T11:59:59.000000Z',
  },
  {
    username: 'staff',
    status: 'downloadable',
    course_display_name: 'Академічна доброчесність',
    grade: '0.88',
    course_id: 'course-v1:Prometheus+AH101+2024_T3',
    course_organization: 'Prometheus',
    modified_date: '2024-09-15T08:20:10.000000Z',
    is_passing: true,
    download_url: 'https://example.com/certificates/ah101-2024',
    certificate_type: 'audit',
    created_date: '2024-09-15T08:20:09.000000Z',
  },
  {
    username: 'staff',
    status: 'downloadable',
    course_display_name: 'Управління проєктами за методологією Agile',
    grade: '0.93',
    course_id: 'course-v1:Prometheus+PM301+2024_T4',
    course_organization: 'Prometheus',
    modified_date: '2024-10-24T16:10:00.000000Z',
    is_passing: true,
    download_url: '/certificates/9a8b7c6d5e4f30211203f4e5d6c7b8a9',
    certificate_type: 'no-id-professional',
    created_date: '2024-10-24T16:09:59.000000Z',
  },
  {
    username: 'staff',
    status: 'downloadable',
    course_display_name: 'Англійська мова для IT-фахівців',
    grade: '0.86',
    course_id: 'course-v1:Prometheus+ENG210+2025_T1',
    course_organization: 'Prometheus',
    modified_date: '2025-01-30T11:45:20.000000Z',
    is_passing: true,
    download_url: 'https://example.com/certificates/eng210-2025',
    certificate_type: 'verified',
    created_date: '2025-01-30T11:45:19.000000Z',
  },
  {
    username: 'staff',
    status: 'downloadable',
    course_display_name: 'Кібербезпека: базовий курс',
    grade: '0.72',
    course_id: 'course-v1:Prometheus+CS150+2025_T1',
    course_organization: 'Prometheus',
    modified_date: '2025-03-18T13:25:05.000000Z',
    is_passing: true,
    download_url: '/certificates/c0ffee00deadbeef1122334455667788',
    certificate_type: 'honor',
    created_date: '2025-03-18T13:25:04.000000Z',
  },
  {
    username: 'staff',
    status: 'downloadable',
    course_display_name: 'Фінансова грамотність для кожного',
    grade: '0.95',
    course_id: 'course-v1:Prometheus+FIN100+2025_T2',
    course_organization: 'Prometheus',
    modified_date: '2025-05-22T19:00:00.000000Z',
    is_passing: true,
    download_url: 'https://example.com/certificates/fin100-2025',
    certificate_type: 'professional',
    created_date: '2025-05-22T18:59:59.000000Z',
  },
];

export default mockData;
